import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { CreateDisbursementFormFields } from "../Hooks/useCreateDisbursementForm";
import { RadioGroup, FormControlLabel, Radio, Grid } from "@material-ui/core";
import useStyles from "./styles";
import pretty from "Shared/pretty";
import useEnterBankAccountFormFields from "./useEnterBankAccountFormFields";
import { DPTextField } from "Components/DP";

const bankAccountTypeRadioButtons = ["CHECKING", "SAVINGS"];

const BankAccountEnter = () => {
  const classes = useStyles();
  const { control, errors, register } = useFormContext<
    CreateDisbursementFormFields
  >();

  const fields = useEnterBankAccountFormFields();

  return (
    <>
      <div className={classes.enterAccount}>
        <div className={classes.enterAccountHeader}>Enter New Account</div>
        <div className={classes.enterAccountFields}>
          <Grid container spacing={1}>
            {fields.map(({ label, name, placeholder, registerValue }) => (
              <React.Fragment key={name}>
                <Grid container item justify="center">
                  <Grid item xs={6}>
                    <label className={classes.enterAccountLabel} htmlFor={name}>
                      {label}
                    </label>
                  </Grid>
                  <Grid item xs={6}>
                    <DPTextField
                      className={classes.enterAccountField}
                      inputProps={{ className: classes.enterAccountInput }}
                      inputRef={register({
                        pattern: /^\d+$/,
                        required: true,
                        ...registerValue,
                      })}
                      name={name}
                      placeholder={placeholder}
                      required
                      type="integer"
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
                {errors && errors[name] && (
                  <Grid container item xs={12}>
                    <div className={classes.error}>
                      {errors[name]!.message || `${label} cannot be blank.`}
                    </div>
                  </Grid>
                )}
              </React.Fragment>
            ))}
          </Grid>
          <Controller
            as={
              <RadioGroup className={classes.bankAccountTypeRadioGroup}>
                {bankAccountTypeRadioButtons.map(bankAccountTypeValue => (
                  <FormControlLabel
                    className={classes.radioGroupOption}
                    control={<Radio color="primary" />}
                    key={bankAccountTypeValue}
                    label={pretty.titleizeWord(bankAccountTypeValue)}
                    labelPlacement="end"
                    value={bankAccountTypeValue}
                  />
                ))}
              </RadioGroup>
            }
            control={control}
            name="bankAccountType"
          />
        </div>
      </div>
    </>
  );
};

export default BankAccountEnter;
